module.exports = __webpack_public_path__ + "img/ScrollDown.b9ec5194.svg";